import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import TimeOffHead from '@/types/table/timeOffHead';
import { OvertimeHoursData } from '@/api/generated/overtimeHoursController';
import { API_CONTEXT } from '../config';
import { FilesManageData } from '@/api/generated/filesManageController';

const { buildGetUrl } = useUrlBuilder();

export interface TimeOffHeadData extends TimeOffHead {
  overtimeHours?: OvertimeHoursData;
  filesManage?: FilesManageData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class TimeOffHeadController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<TimeOffHeadData>>(API_CONTEXT + '/app/timeOffHead/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<TimeOffHeadData>(API_CONTEXT + '/app/timeOffHead/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/timeOffHead/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/timeOffHead/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/timeOffHead/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/timeOffHead/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/timeOffHead/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/timeOffHead/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/timeOffHead/deleteBatch', params, httpOptions);
  }
  static startOnlyFlowTimeOff(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/timeOffHead/startOnly/flowTimeOff', params, httpOptions);
  }
  static startWithBusinessKeyFlowTimeOff(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/timeOffHead/startWithBusinessKey/flowTimeOff', params, httpOptions);
  }
  static editorTakeUserTaskFlowContract(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/timeOffHead/editorTakeUserTaskFlowContract/editorTakeUserTaskFlowContract', params, httpOptions);
  }

    static startAndTakeUserTaskFlowTimeOff(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/timeOffHead/startAndTakeUserTask/flowTimeOff', params, httpOptions);
  }
  static startAndSaveDraftFlowTimeOff(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/timeOffHead/startAndSaveDraft/flowTimeOff', params, httpOptions);
  }
  static submitUserTaskFlowTimeOff(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/timeOffHead/submitUserTask/flowTimeOff', params, httpOptions);
  }
  static viewTaskBusinessDataFlowTimeOff(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/timeOffHead/viewTaskBusinessData/flowTimeOff', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataFlowTimeOff(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/timeOffHead/viewHistoricTaskBusinessData/flowTimeOff', params, httpOptions);
  }
  static listWorkOrderFlowTimeOff(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/timeOffHead/listWorkOrder/flowTimeOff', params, httpOptions);
  }
  static getUserOvertimeHoursFlowTimeOff(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/timeOffHead/getUserOvertimeHours/flowTimeOff', params, httpOptions);
  }
  static getHolidaysFlowTimeOff(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/timeOffHead/getHolidays/flowTimeOff', params, httpOptions);
  }
  static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }
}
